module.exports = __webpack_public_path__ + "static/media/portrait.e2c47939.jpg";